import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/** Cuerpo POST /viajes (opcional: tkt_h, rutconductor_base64, etc. según Swagger). */
export type TransportistaViajesListBody = Record<string, unknown>;

/**
 * Normaliza la respuesta del gateway al envelope que espera `OrderService.mapOrdersFromApi`.
 */
export function toLegacyViajesEnvelope(
  raw: unknown
): { datos: Array<{ VIAJESH: any[] }> } {
  if (!raw || typeof raw !== 'object') {
    return { datos: [{ VIAJESH: [] }] };
  }
  const r = raw as Record<string, unknown>;
  const datos = r['datos'];
  if (Array.isArray(datos) && datos.length > 0) {
    const row = datos[0] as Record<string, unknown>;
    const viajes = row['VIAJESH'] ?? row['viajesh'];
    if (Array.isArray(viajes)) {
      return { datos: [{ VIAJESH: viajes }] };
    }
  }
  const top = r['VIAJESH'] ?? r['viajesh'];
  if (Array.isArray(top)) {
    return { datos: [{ VIAJESH: top }] };
  }
  return { datos: [{ VIAJESH: [] }] };
}

/** POST /api/transportista/viajes */
@Injectable({ providedIn: 'root' })
export class TransportistaViajesGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: TransportistaViajesListBody = {},
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/viajes', body, options);
  }
}
